import {
  Button,
  Radio,
  RadioGroup,
  Text
} from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow, { FilterGroup } from '../../reusable/Layout';

const O2O_EVENT_OPTIONS = [
  { id: 'BOPIS', label: 'BOPIS', value: 'BOPIS' },
  { id: 'SFS', label: 'SFS', value: 'SFS' },
  { id: 'DSIS', label: 'DSIS', value: 'DSIS' },
];

const O2OEvents = ({ onFilterValueChange, translations }) => {
  const nposFilters = useSelector((state) => state.nposFilters);
  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_O2OEvents}</Text>
        <div className="d-sm-flx flx-ai-sm-c mb4-sm" style={{ gap: '40px' }}>
          <RadioGroup
            data-testid="o2o-radio-group"
            id="o2oEvent"
            orientation="horizontal"
            valueSelected={nposFilters.o2oEvent}
            onChange={(e) => onFilterValueChange({ id: 'o2oEvent', value: e.target.value })}
          >
            {O2O_EVENT_OPTIONS.map(({ id, label }) => (
              <Radio
                key={id}
                data-testid={`o2o-event-radio-${id}`}
                id={id}
                label={label}
                value={id}
              />
            ))}
          </RadioGroup>
          <Button
            className="mt4-sm"
            hidden={!nposFilters.o2oEvent}
            size="small"
            variant="primary"
            onClick={() => onFilterValueChange({ id: 'o2oEvent', value: '' })}
          >
            {translations.RL_Reset}
          </Button>
        </div>
      </FilterRow>
    </FilterGroup>
  );
};

O2OEvents.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default O2OEvents;
